export const Form = {
    init: function () {
        this.cacheSelectors();
        this.addEventListeners();
    },

    cacheSelectors: function () {
        this.nameField = document.querySelector('input[name="phone-1"]');
    },

    addEventListeners: function () {
        if (this.nameField) {
            this.nameField.addEventListener("input", this.Methods.handleInput);
        }
    },

    Methods: {
        handleInput: function (event) {
            let input = event.target;
            let value = input.value.replace(/\D/g, ''); 
            
            value = Form.Methods.limitLength(value, 11);

            input.value = value.length >= 10 ? Form.Methods.applyMask(value) : value;
        },

        limitLength: function (value, maxLength) {
            return value.length > maxLength ? value.slice(0, maxLength) : value; 
        },

        applyMask: function (value) {
            const mask = value.length === 11
                ? new RegExp('^(\\d{2})(\\d{1})(\\d{4})(\\d{0,4})$', 'g') 
                : value.length === 10
                    ? new RegExp('^(\\d{2})(\\d{4})(\\d{0,4})$', 'g')  
                    : null;

            if (value.length === 11) {
                return value.replace(mask, '($1) $2 $3-$4'); 
            } else if (value.length === 10) {
                return value.replace(mask, '($1) $2-$3'); }

            return value;  }
    }
};

document.addEventListener('DOMContentLoaded', () => {
    Form.init();
});
